// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableProjects-module__actionDropdown--dJZHO .ant-dropdown-menu-item-disabled {\n  display: none!important;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/InvestmentProjects/components/TableProjects/TableProjects.module.less"],"names":[],"mappings":"AAAA;EAEI,uBAAA;AAAJ","sourcesContent":[".actionDropdown{\n  :global(.ant-dropdown-menu-item-disabled) {\n    display: none!important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionDropdown": "TableProjects-module__actionDropdown--dJZHO"
};
export default ___CSS_LOADER_EXPORT___;
